<template>
  <v-container fluid class="px-0">
    <v-card outlined class="my-0">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6" lg="3">
                <el-text-field
                  label="Reg. Nr. nepatikrintų dokumentų žurnale"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Nepatikrintų dokumentų žurnalas. Reg nr Nepatikrintų dokumentų žurnale"
                  v-model="mainData['ns-search-custom']"
                  hide-details
                  :maxlength="1000"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="filteredInJournalType"
                  multiple
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Nepatikrinto dokumento pavadinimas"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gauto dokumento pavadinimas"
                  v-model="mainData['in_journal_type-search-in']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="enumsClassifiers.checkingStatus"
                  multiple
                  enums
                  hide-details
                  itemvalue="value"
                  itemtext="text"
                  label="Sprendimas"
                  v-model="mainData['signing_status-search-custom']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :beforeDates="mainData['received_date_ns_to-search-custom']"
                  label="Gavimo data nuo"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gavimo data nuo"
                  v-model="mainData['received_date_ns_from-search-custom']"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6" lg="3">
                <el-date-picker
                  :afterDates="mainData['received_date_ns_from-search-custom']"
                  label="Gavimo data iki"
                  tooltip="Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Gavimo data iki"
                  v-model="mainData['received_date_ns_to-search-custom']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Enums from '@/enums'
import moment from 'moment'

export default {
  name: 'AdminCheckingJournalSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
    enumsClassifiers: [],
  }),
  computed: {
    ...mapGetters(['searchParams']),
    filteredInJournalType(){
      return  this.enumsClassifiers.checkingInJournalStatuses
    },
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getClassifiers()
    // this.setDateFrom()
     this.searchData()
  },
  methods: {
    setDateFrom(){
      if(!this.mainData.autoSet){
        let date = moment().subtract(3, 'days').format('YYYY-MM-DD') 
        this.$set(this.mainData, 'date_received-search-custom', date)
        this.$set(this.mainData, 'autoSet', true)
      } 
      this.searchData()
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getClassifiers() {
      this.enumsClassifiers = Enums
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData(button) {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      searchData.btn = button
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      let autoSet = this.mainData?.autoSet || false
      this.mainData = {isExpanded: true, clear: true}
      this.$nextTick(() => {
        this.mainData = { isExpanded: true, autoSet: autoSet }
        this.searchData(true)
      })
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
            this.searchData(true)
        } 
      })
    },
  },
}
</script>
